import { MLSListing } from '@aloft/toolkit-shared';

import MLSDataColumn from './MLSDataColumn.js';
import MLSDataInfoSection from './MLSDataInfoSection.js';
import MlsDataValueWithLabel from './MLSDataValueWithLabel.js';

const MLSFeatures = ({ listingData }: { listingData: MLSListing }) => (
  <MLSDataInfoSection title="Features" spanColumns={true}>
    <MLSDataColumn>
      <MlsDataValueWithLabel value={listingData.DoorFeatures} label="Doors" />
      <MlsDataValueWithLabel leftAlign value={listingData.Flooring} label="Flooring" />
      <MlsDataValueWithLabel leftAlign value={listingData.Heating?.join(', ')} label="Heating" />
      <MlsDataValueWithLabel leftAlign value={listingData.Cooling} label="Cooling" />
      <MlsDataValueWithLabel
        leftAlign
        value={listingData.ExteriorFeatures?.join(', ')}
        label="Exterior"
      />
      <MlsDataValueWithLabel
        leftAlign
        value={listingData.InteriorFeatures?.join(', ')}
        label="Interior"
      />
      <MlsDataValueWithLabel
        leftAlign
        value={listingData.Appliances?.join(', ')}
        label="Appliances"
      />
      <MlsDataValueWithLabel
        leftAlign
        value={listingData.PatioAndPorchFeatures}
        label="Patio and Porch"
      />
      <MlsDataValueWithLabel leftAlign value={listingData.PoolFeatures} label="Pool" />
    </MLSDataColumn>
  </MLSDataInfoSection>
);

export default MLSFeatures;
